import { Customer, CustomerList, LoadCustomerParams } from "../types/customer";
import { get, post } from "./fetch.core";

function convertBooleanParam(value: any): boolean | undefined {
  if (value === undefined || value === null) {
    return undefined;
  }

  if (typeof value === "boolean") {
    return value;
  }

  if (value === "on" || value === "true") {
    return true;
  }

  if (value === "off" || value === "false") {
    return false;
  }

  return undefined;
}

export async function loadCustomers(params: Partial<LoadCustomerParams>) {
  if (!params.search) {
    delete params.search;
  }

  if (!params.sort) {
    delete params.sort;
  }

  if (!params.sortAsec) {
    delete params.sortAsec;
  }

  if (!params.providers || params.providers.length === 0) {
    delete params.providers;
  }

  if (params.emailVerified === undefined) {
    delete params.emailVerified;
  }
  1;

  if (params.mobileNumberVerified === undefined) {
    delete params.mobileNumberVerified;
  }

  if (params.suspended === undefined) {
    delete params.suspended;
  }

  if (params.blacklisted === undefined) {
    delete params.blacklisted;
  }

  if (!params.dateFrom) {
    delete params.dateFrom;
  }

  if (!params.dateTo) {
    delete params.dateTo;
  }

  if (!params.membershipIds || params.membershipIds.length === 0) {
    delete params.membershipIds;
  }

  return (await post<CustomerList>("/admin/user/list", params)).data;
}

export async function getSingle(customerId: string) {
  return (await get<Customer>(`/admin/user/getSingle?customerId=${customerId}`)).data;
}

export async function getRewardPoints(customerId: string) {
  return (await get<{ points: number }>(`/admin/user/getRewardPoints?customerId=${customerId}`)).data;
}

export async function getRewardPointsBatch(customerIds: string[]) {
  return (
    await post<{ pointsByCustomerId: Record<string, number> }>("/admin/user/getRewardPointsBatch", { customerIds })
  ).data;
}

export async function getGiftCardPoints(customerId: string) {
  return (await get<{ points: number }>(`/admin/user/getGiftCardPoints?customerId=${customerId}`)).data;
}

export async function getGiftCardPointsBatch(customerIds: string[]) {
  return (
    await post<{ pointsByCustomerId: Record<string, number> }>("/admin/user/getGiftCardPointsBatch", { customerIds })
  ).data;
}

export async function createCustomer(data: {
  firstName: string;
  lastName: string;
  mobileNumber?: string;
  email: string;
  password: string;
}) {
  return (await post<Customer>("/admin/user/create", data)).data;
}

export async function suspendCustomer(customerId: string) {
  return (await post<{ message: string }>("/admin/user/suspend", { customerId })).data;
}

export async function unsuspendCustomer(customerId: string) {
  return (await post<{ message: string }>("/admin/user/unsuspend", { customerId })).data;
}

export async function blacklistCustomer(customerId: string) {
  return (await post<{ message: string }>("/admin/user/blacklist", { customerId })).data;
}

export async function unblacklistCustomer(customerId: string) {
  return (await post<{ message: string }>("/admin/user/unblacklist", { customerId })).data;
}

export async function updateMobileNumberVerified(customerId: string, verified: boolean) {
  return (await post<{ message: string }>("/admin/user/updateMobileNumberVerified", { customerId, verified })).data;
}

export async function updateEmail(customerId: string, email: string) {
  return (await post<{ message: string }>("/admin/user/updateEmail", { customerId, email })).data;
}

export async function updateMobileNumber(customerId: string, mobileNumber: string) {
  return (await post<{ message: string }>("/admin/user/updateMobileNumber", { customerId, mobileNumber })).data;
}

const customerCore = {
  loadCustomers,
  getSingle,
  getRewardPoints,
  getRewardPointsBatch,
  getGiftCardPoints,
  getGiftCardPointsBatch,
  createCustomer,
  suspendCustomer,
  unsuspendCustomer,
  blacklistCustomer,
  unblacklistCustomer,
  updateMobileNumberVerified,
  updateEmail,
  updateMobileNumber,
};

export default customerCore;
